import createAction from '../../../../util/createAction';

export const ROUTE = 'promotion/ROUTE';

export default createAction(ROUTE);
